import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromDtoToStylistPermissions from 'dto/access/fromDtoToStylistPermissions.dto';
import fromStylistPermissionsToDto from 'dto/access/fromStylistPermissionsToDto.dto';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const abeStylistPermissionsRead = actionEndpointBe('abeStylistPermissionsRead', H.get, 'salon/v2/:salonId/custom_permissions/:stylistId/', (options, extra) => ({
  ...options,
  inert: false,
  fromDto: fromDtoToStylistPermissions,
  params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
  umsg: UMSG_TYPE.global,
}));

export const ibeStylistPermissionsRead = actionEndpointBe('ibeStylistPermissionsRead', H.get, 'salon/v2/:salonId/custom_permissions/:stylistId/', (options, extra) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToStylistPermissions,
  params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
  umsg: UMSG_TYPE.global,
}));

export const abeStylistPermissionsUpdate = actionEndpointBe('abeStylistPermissionsRead', H.patch, 'salon/v2/:salonId/custom_permissions/:stylistId/', (options, extra) => ({
  ...options,
  inert: false,
  fromDto: fromDtoToStylistPermissions,
  toDto: fromStylistPermissionsToDto,
  data: extra?.data,
  params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
  umsg: UMSG_TYPE.global,
}));

export const ibeStylistPermissionsUpdate = actionEndpointBe('ibeStylistPermissionsRead', H.patch, 'salon/v2/:salonId/custom_permissions/:stylistId/', (options, extra) => ({
  ...options,
  inert: false,
  fromDto: fromDtoToStylistPermissions,
  toDto: fromStylistPermissionsToDto,
  data: extra?.data,
  params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
  umsg: UMSG_TYPE.global,
}));
